// material
import { Stack, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

// ----------------------------------------------------------------------
const AnimationStyle = styled(Stack)(() => ({
  "@keyframes spin": {
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

export default function PartnerHead(props) {
  return (
    <Stack
      direction="row"
      sx={{
        borderBottom: "1px solid #ffffff80",
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{ borderRight: "1px solid #ffffff80", width: "12%" }}
      >
        <AnimationStyle>
          <Box
            component="img"
            alt="text"
            src="/assets/text.png"
            sx={{
              width: { xs: "50px", sm: "70px", lg: "100px", xl: "130px" },
              height: { xs: "50px", sm: "70px", lg: "100px", xl: "130px" },
              animation: "spin 12s linear infinite",
            }}
          />
        </AnimationStyle>
      </Stack>
      <Stack justifyContent="center" sx={{ pl: "1%", width: "88%" }}>
        <p className="head_text">{props.title}</p>
      </Stack>
    </Stack>
  );
}
